<template>
<div>
    <div class="myDialog" @click="close()">
        <div class="content">
            <img class="img" :src="info.imgsrc" alt="">
            <div class="text">
                <p class="title">{{info.title}}</p>
                <p class="subTitle">{{info.subTitle1}}&nbsp;&nbsp;{{info.subTitle2}}</p>
            </div>
            <a :href="'tel:' + phone" class="btn">{{info.btnText}}</a>
        </div>
    </div>
</div>
</template>

<script>
export default {
     data() {
        return {
            info:"",
            phone:""
        };
    },
    created(){
        this.info=this.$route.query.info;
        this.phone= this.$route.query.phone;
        console.log( this.$route.query.info, this.$route.query.phone)
       
    },
    methods: {
        close(){
            this.$router.go(-1);//返回上一层
        },
    },
    computed:{
    },
}
</script>

<style scoped>
    .myDialog{
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
        background: #fff;
        z-index: 9;
       
    }
    .content{
        width: 100%;
        position: absolute;
        bottom: 7%;
         display: flex;
        flex-direction: column;
        align-items: center;
    }
    .img{
        width:72%;

    }
    .text{
        margin-top: 8%;
        margin-bottom: 13%;
    }
    .title{
        font-size: 20px;
        color: #333;
        font-family:Source Han Sans CN;
    }
    .subTitle{
        font-size: 16px;
        color: #333;
        font-family:Source Han Sans CN;
    }
    .btn{
        width: 80%;
        font-size: 16px;
        color: #fff;
        background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
        display: block;
        border-radius: 999px;
        height: 40px;
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/my/myDialog.vue